/**
 * utm_medium=sbol - переход из ПДЖ (Проект Сбера), скрывает:
 *    - плашку куки
 *    - все баннеры от маркетинга (mindbox script)
 *    - топ-баннер с рекламой
 */

const UTM_SBOL = { key: 'utm_medium', value: 'sbol' }

export const getIsActiveUTMSbol = () => {
  if (typeof window === 'undefined') return

  const inQueryParams =
    typeof window !== 'undefined' && window.location.href.indexOf(`${UTM_SBOL.key}=${UTM_SBOL.value}`) >= 0
  const inLocalStorage = window.localStorage.getItem(UTM_SBOL.key) === UTM_SBOL.value

  return inQueryParams || inLocalStorage
}
